import { State } from 'interfaces/state'
import { createSelector } from 'reselect'

const pushNotificationsSelector = (state: State) => state.app.pushNotifications

export const pushNotificationsPlayerIdSelector = createSelector(
  pushNotificationsSelector,
  (pushNotifications) => pushNotifications.playerId
)
